
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productivityColumns: [],
  nonProductivityColumns: [],
};

const productivityColumnSlice = createSlice({
  name: "productivityColumn",
  initialState,
  reducers: {
    setProductivityColumns(state, action) {
      state.productivityColumns = action.payload;
    },
    setNonProductivityColumns(state, action) {
      state.nonProductivityColumns = action.payload;
    },
  },
});

export const { setProductivityColumns, setNonProductivityColumns } =
  productivityColumnSlice.actions;

export default productivityColumnSlice.reducer;
